import styled from "styled-components";

const AttributeValue = styled.div.attrs(() => ({ className: "mb-2 best-attribute-value" }))``;

export default AttributeValue;
